















import { defineComponent } from '@vue/composition-api';

const name = 'ttam-question-tooltip-with-image';
export default defineComponent({
  props: {
    placement: {
      type: String,
      default: 'top',
    },
    trigger: {
      type: String,
      default: 'hover',
    },
    width: {
      type: Number,
      default: 211,
    },
    containerClass: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      name,
    };
  },
});
